import React, { useEffect, useState, useRef } from "react";
import { Header, Grid, Divider, Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { useDispatch } from "react-redux";

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  pdf,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
const TravelPackListWithCatNew = (props) => {
  const disptch = useDispatch();
  const { categoryId } = props;
  const navigate = useNavigate();
  const createNew = () => {
    navigate(`/create-tour-package-new/null/${categoryId}`);
  };
  const userDetail = userData();
  const [hotelList, setHotelList] = useState([]);
  useEffect(() => {
    getHotelList();
  }, [disptch]);

  const [rowData, setrowData] = useState(null);
  const getinvoiceList = () => {
    const postObject = {
      categoryId: categoryId,
      getAll: categoryId === 0 ? true : false,
    };

    console.log("skxnmosncnscs", postObject);
    axios
      .post(BaseUrlInvoice + "accounts/listTourInvoice", postObject)
      .then((res) => {
        console.log("Invoice List", res.data);

        // Map through the response data and add hotel names
        const invoicesWithHotelNames = res.data.map((invoice) => {
          // Assuming hotelId is the field containing the hotel ID in the invoice data
          const hotel = hotelList.find(
            (item) => item.value === invoice.hotelName
          );
          return {
            ...invoice,
            hotelName: hotel ? hotel.text : "", // Add hotel name to the invoice object
          };
        });

        console.log("Invoice List:", invoicesWithHotelNames);

        setrowData(invoicesWithHotelNames);
        // setrowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getHotelList = async () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 568,
      })
      .then((res) => {
        console.log("res", res.data);
        const hotelName = res.data.map((item) => ({
          text: item.categoryName,
          value: item.categoryId,
        }));
        setHotelList(hotelName);
        getinvoiceList();
      });
  };

  const columnDefs = [
    { headerName: "Date ", field: "invoiceDate", flex: 2 },
    { headerName: "Name ", field: "invoiceName", flex: 2 },
    { headerName: "Contact ", field: "customerContact", flex: 2 },
    { headerName: "Invoice Number", field: "invoiceNumber", flex: 2 },
    { headerName: "Driver Name", field: "driverName", flex: 2 },
    { headerName: "Driver Number", field: "driverNumber", flex: 2 },
    { headerName: "Tour Operator", field: "tourOperator", flex: 2 },
    // { headerName: "Hotel", field: "hotelName", flex: 2 },
    {
      headerName: "Hotel",
      field: "hotelName",
      flex: 2,
      cellRendererFramework: (params) => {
        const hotel = hotelList.find(
          (item) => item.value === params.data.hotelName
        );
        return <div>{hotel ? hotel.text : ""}</div>;
      },
    },

    {
      headerName: "Actions",
      filter: false,
      field: "ssTourInvoiceId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View{" "}
          </Button>
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrlInvoice + "/accounts/deleteTourInvoice", {
            ssTourInvoiceId: params.data.ssTourInvoiceId,
          })
          .then((res) => {
            console.log("data has deleted", res.data);
            Swal.fire("Deleted!", "Invoice has been deleted.", "success");
            getinvoiceList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const actionButton = (params) => {
    console.log(params.data.dailyWorkId);
    navigate(
      `/create-tour-package-new/${params.data.ssTourInvoiceId}/${categoryId}`
    );
    // history.push(
    //   `/attraction/attraction-creation/${params.data.attractionsId}`
    // ); /
  };

  const defaultColDef = {
    sortable: true,
    editable: false,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <Grid.Row>
        {/* <Header dividing size="huge" as="h1">
          Invoice List
        </Header> */}
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <div>
          <Button type="submit" primary onClick={() => createNew()}>
            Create New
          </Button>

          {rowData !== null && (
            <Button
              color="primary"
              onClick={(e) => exportToCSV(rowData, "Invoice_List")}
            >
              Download CSV
            </Button>
          )}
        </div>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default TravelPackListWithCatNew;
